import { render, staticRenderFns } from "./diffhalflist.vue?vue&type=template&id=3907713a&scoped=true"
import script from "./diffhalflist.vue?vue&type=script&lang=js"
export * from "./diffhalflist.vue?vue&type=script&lang=js"
import style0 from "./diffhalflist.vue?vue&type=style&index=0&id=3907713a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3907713a",
  null
  
)

export default component.exports